import { render, staticRenderFns } from "./WorkContentModal.html?vue&type=template&id=33f57342&scoped=true&external"
import script from "./WorkContentModal.js?vue&type=script&lang=js&external"
export * from "./WorkContentModal.js?vue&type=script&lang=js&external"
import style0 from "./WorkContentModal.scss?vue&type=style&index=0&id=33f57342&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f57342",
  null
  
)

export default component.exports